import {DisplayObject, Point, Sprite} from 'pixi.js';
import {Card} from './game_table/table_objects/stacks/Card';
import {CardEvents} from './game_table/table_objects/stacks/card/CardEvents';
import {ArrayWrap} from '../../data/active_data/base/static_config_data/ArrayWrap';
import {ActiveData} from '../../data/ActiveData';
import {CardData, ICardData} from '../../data/active_data/field_config/card_stack_data/CardData';

export class SceneCardsHolder extends Sprite
{
    private cards: Card[] = [];
    private onHandTakeCardsBindThis: (e: Event) => void;
    private onHandPutCardsBindThis: (e: Event) => void;

    constructor() {
        super();

        this.onHandTakeCardsBindThis = this.onHandTakeCards.bind(this);
        this.onHandPutCardsBindThis = this.onHandPutCards.bind(this);

        addEventListener(CardEvents.ON_HAND_TAKE_VIRTUAL_CARDS, this.onHandTakeCardsBindThis);
        addEventListener(CardEvents.ON_HAND_RETURN_VIRTUAL_CARDS, this.onHandPutCardsBindThis);
    }

    private _handPosition: Point = new Point();

    set handPosition(position: Point) {
        this._handPosition.set(position.x, position.y);
    }

    destroy(): void {
        removeEventListener(CardEvents.ON_HAND_TAKE_VIRTUAL_CARDS, this.onHandTakeCardsBindThis);
        removeEventListener(CardEvents.ON_HAND_RETURN_VIRTUAL_CARDS, this.onHandPutCardsBindThis);

        delete this.onHandTakeCardsBindThis;
        delete this.onHandPutCardsBindThis;

        super.destroy({children: true});
    }

    private onHandTakeCards(e: Event): void {
        let data: {cards: Card[]} = (e as MessageEvent).data;
        data.cards.forEach(card => {
            this.addChild(card);
            this.cards.push(card);
            card.x += this._handPosition!.x;
            card.y += this._handPosition!.y;
        });

        let playerCards: ArrayWrap<CardData, ICardData> = ActiveData.root.getCurrentPlayerData().cards;
        this.children.sort((card1: DisplayObject, card2: DisplayObject) => {
            return playerCards.indexOf((card1 as Card).activeData) - playerCards.indexOf((card2 as Card).activeData);
        });
    }

    private onHandPutCards(e: Event): void {
        let data: {cards: Card[]} = (e as MessageEvent).data;
        data.cards.forEach(card => {
            this.removeChild(card);
            this.cards.splice(this.cards.indexOf(card), 1);
        });
    }
}
